module.exports = __webpack_public_path__ + "img/password.20864d39.svg";